import { render } from "./payment-links.vue?vue&type=template&id=3a473ab9"
import script from "./payment-links.vue?vue&type=script&lang=js"
export * from "./payment-links.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__